export const getInlineHelpButtonStyles = ({ palette, iconFontFamily }) => ({
  '& .helpbutton': {
    paddingTop: '2px',
    paddingLeft: '2px',

    '&::before': {
      content: '"\\E9CE"',
      fontFamily: iconFontFamily,
      position: 'relative',
      color: palette.themePrimary,
      verticalAlign: 'middle',
    },

    '&:focus': {
      outline: '1px solid',
      outlineColor: palette.neutralSecondary,
      border: 'none',
      color: palette.black,
      textDecoration: 'none',
    },

    '&:hover': {
      backgroundColor: palette.neutralLighter,
      color: palette.black,
      textDecoration: 'none',
    },

    '&:active': {
      backgroundColor: palette.neutralLight,
      color: palette.black,
      textDecoration: 'none',
    },
  },
});
